import React from "react";
import { color } from "@ui";
import Badge from "@ui/Badge";
import { CheckboxCircleFill, CircleLine, Progress5Line } from "@ui/IconV2/react";
import { css } from "@linaria/core";
import {
  FAULT_EVENTS_STATUS_BACKGROUND_COLORS,
  FAULT_EVENTS_STATUS_COLORS,
  getEventStatusText,
  type DenormalizedEventStatus,
} from "../../utils/faultEventStatus";
import classNames from "classnames";

const badge = css`
  display: inline-flex;
  max-width: fit-content;
  height: fit-content;

  & > :first-child {
    flex-shrink: 0;
  }
`;

interface P extends React.HTMLAttributes<HTMLDivElement> {
  status: DenormalizedEventStatus;
}

const StatusIcon = ({ status }: { status: DenormalizedEventStatus }) => {
  const color = FAULT_EVENTS_STATUS_COLORS[status];
  const size = "s";
  if (status === "TO_BE_ANALYSED") return <CircleLine color={color} size={size} />;
  if (status === "ONGOING") return <Progress5Line color={color} size={size} />;
  if (status === "ACTION_IDENTIFIED") return <CheckboxCircleFill color={color} size={size} />;
  return null;
};

export const BadgeEventStatus = ({ className, status }: P) => (
  <Badge
    className={classNames(className, badge)}
    color={color.carbon800}
    backgroundColor={FAULT_EVENTS_STATUS_BACKGROUND_COLORS[status]}
    icon={<StatusIcon status={status} />}
    size="m"
  >
    {getEventStatusText(status)}
  </Badge>
);
